export const theme = {
  token: {
    fontSize: 14,
    colorPrimary: "#0066CC",
    colorError: "#B53939",
    colorSuccess: "#05ccf0",
    colorText: "#000",
  },

  components: {
    Button: {
      algorithm: true,
      fontSize: 14,
      contentFontSizeLG: 14,
      paddingBlock: 20,
      paddingInlineLG: 20,
      paddingInlineSM: 20,
      paddingInline: 10,
      fontWeight: 500,

      colorBgDisabled: "#5ca7ed",
      colorTextDisabled: "#000",
    },
    DatePicker: {
      algorithm: true,
      fontSize: 12,
      // borderRadiusLG: 4,
      // borderRadiusSM: 4,
      // borderRadius: 4,
      paddingBlock: 0,
      paddingInline: 10,
      paddingInlineSM: 10,
      paddingInlineLG: 10,
      colorPrimary: "#0066CC",
    },
    Select: {
      algorithm: true,
      fontSize: 12,
    },
    Table: {
      algorithm: true,
      fontSize: 12,
      borderRadiusLG: 4,
      borderRadiusSM: 4,
      borderRadius: 4,
      paddingBlock: 0,
      paddingInline: 10,
      paddingInlineSM: 10,
      paddingInlineLG: 10,
      colorPrimary: "#0066CC",
      colorTextHeading: "#000",
      colorTextLabel: "#000",
    },
    Divider: {
      algorithm: true,
      margin: 0,
      marginLG: 0,
      marginXS: 0,
    },
    Spin: {
      algorithm: true,
      size: 20,
      colorPrimary: "#0d195c",
    },
    Input: {
      algorithm: true,
      hoverBorderColor: "#0066CC",
      activeShadow: 0,
      fontSize: 12,
    },
  },
};
